/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateConsentDecision} from '../api'

export const useMutationUpdateConsentDecision = createReactQueryMutationHook('updateConsentDecision', updateConsentDecision)
